<template>
  <b-modal id="clinic-show-template" class="clinic-show-template" ref="modal" :title="dialog_title" hide-footer>
    <div class="form-group row">
      <div class="col-sm-6">
        <input placeholder="Introduce el nombre del plantilla" v-model="title" type="text" id="show_template_title"
          class="form-control" required />
        <label class="wabident-info" for="show_template_title">Título de la Plantilla</label>
      </div>

      <div class="col-sm-3">
        <select v-model="format" name="format" id="show_template_format" class="custom-select">
          <option value="html">HTML5</option>
          <option value="rich">Visual</option>
          <option value="markdown">Markdown</option>
          <option v-if="false" value="pdf">PDF</option>
        </select>
        <label for="show_template_format" class="wabident-info">Formato</label>
      </div>

      <div class="col-sm-3">
        <select v-model="type" name="type" id="show_template_type" class="custom-select">
          <option value="consent">Consentimiento</option>
          <option value="proof">Justificante</option>
          <option value="report">Informe</option>
        </select>
        <label for="show_template_type" class="wabident-info">Tipo de Plantilla</label>
      </div>
    </div>
    <div class="form-group row">
      <div class="col">
        <!-- RICH HTML EDITOR -->
        <quill-editor v-if="format == 'rich'" id="show_template_content" ref="quilleditor" :options="options"
          v-model="content" @ready="onEditorReady"></quill-editor>
        <!-- MARKDOWN EDITOR -->
        <prism-editor v-if="format == 'html' || format == 'markdown'" class="content-editor" ref="prismeditor"
          v-model="content" :language="lang"></prism-editor>
        <!-- PDF UPLOADER -->
        <b-form-file v-if="format == 'pdf'" v-model="file" :state="Boolean(file)" placeholder="Sube un archivo PDF"
          class="wabident-file-input" :required="!is_editing" :accept="file_accept"
          :disabled="is_loading"></b-form-file>
      </div>

      <div v-if="format == 'rich'" class="col-sm-2">
        <legend><strong>MACROS</strong></legend>
        <details class="macro-section" v-for="(submacros, section_name) in macros" :key="section_name">
          <summary><strong>{{ section_name }}</strong></summary>
          <div class="macro-section__content" v-for="(name, index) in submacros" :key="index">
            <button role="button" class="macro-section__item btn btn-block btn-wabident-round small m-2"
              @click="insertMacro(index)">{{ name }}</button>
          </div>
        </details>
      </div>
    </div>
    <div class="form-group row">
      <div class="col text-center">
        <button :disabled="is_loading" @click="onDelete" v-show="is_editing" class="btn btn-wabident-delete float-left"
          style="width: 53.6px; height: 53.6px"></button>
        <button :disabled="is_loading" type="button" @click="onSubmit" class="btn btn-primary btn-wabident">
          <span v-if="is_loading">Guardando ...</span>
          <span v-else-if="is_editing">Modificar Plantilla</span>
          <span v-else>Crear Plantilla</span>
          <i v-if="is_loading" class="fas fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      type: "consent",
      content: "",
      position: "",
      format: "rich",
      is_editing: false,
      is_loading: false,
      template: null,
      file: null,
      file_accept: 'application/pdf',
      macros: {
        'Firmas': {
          '@Firma@': 'Cuadro de firmas',
        },
        'Documento': {
          '@Titulo@': 'Título del documento',
          '@Fecha@': 'Fecha del documento',
          '@Hora@': 'Hora del documento',
          '@Revocado@': 'Revocado: Sí o No',
          '@FechaRevocacion@': 'Fecha de Revocación',
        },
        'Clínica': {
          '@NombreClinica@': 'Nombre',
          '@NIFClinica@': 'NIF',
          '@DireccionClinica@': 'Dirección',
          '@CiudadClinica@': 'Ciudad',
          '@CPClinica@': 'Código Postal',
          '@EmailClinica@': 'Email',
          '@TlfClinica@': 'Teléfono',
          '@LogoClinica@': 'Logo',
        },
        'Paciente': {
          '@NombrePacienteReal@': 'Nombre',
          '@EdadPaciente@': 'Edad',
          '@FechaNacPaciente@': 'Fecha Nac.',
          '@NIFPacienteReal@': 'NIF',
          '@HistoriaPaciente@': 'Num. Historia',
          '@DireccionPaciente@': 'Dirección',
          '@CiudadPaciente@': 'Ciudad',
          '@CPPaciente@': 'Código Postal',
          '@EmailPaciente@': 'Email',
          '@TlfPaciente@': 'Teléfono',
          '@FirmaPaciente@': 'Firma',
          '@FirmaPaciente@': 'Firma Revocación',
        },

        'Representante': {
          '@NombreRepresentante@': 'Nombre',
          '@NombreRepresentado@': 'Representado/a',
          'NIFRepresentante@': 'NIF',
        },

        'Doctor': {
          '@TituloDoctor@': 'Título',
          '@NombreDoctor@': 'Nombre',
          '@EmailDoctor@': 'EmailDoctor',
          '@NumColegiadoDoctor@': 'Num. Colegiado',
          '@FirmaDoctor@': 'Firma',
          '@FirmaDoctorRevocado@': 'Firma Revocación',
        },

        'Doctor 2': {
          '@TituloDoctor2@': 'Título',
          '@NombreDoctor2@': 'Nombre',
          '@EmailDoctor2@': 'EmailDoctor',
          '@NumColegiadoDoctor2@': 'Num. Colegiado',
          '@FirmaDoctor2@': 'Firma',
          '@FirmaDoctorRevocado2@': 'Firma Revocación',
        }
      },
      options: {
        placeholder: "Introduce texto ...",
        modules: {
          toolbar: {
            container: [
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              ["bold", "italic", "underline", "strike"],
              [{ align: [] }, { list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
              ["blockquote", "code-block", "link"],
              ["clean"],
            ],
          },
        },
      },
    };
  },
  watch: {
    file(f) {
      if (f) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64String = e.target.result;
          this.content = base64String.split(',')[1];
          console.log(this.content);
        };
        reader.readAsDataURL(f);
      } else {
        this.content = null;
      }
    },
  },
  computed: {
    lang() {
      switch (this.format) {
        case "markdown":
          return "md";
        default:
          return "html";
      }
    },
    dialog_title() {
      return this.is_editing ? "Modificar Plantilla" : "Nueva Plantilla";
    },
    ...mapGetters(["msgwindow"]),
  },
  methods: {
    insertMacro(value) {
      if (this.format == 'rich') {
        let quill = this.$refs.quilleditor.quill;
        let selection = quill.getSelection(true);
        quill.insertText(selection.index, value);
      }
    },
    showNew() {
      this.is_editing = false;
      this.template = null;
      this.title = "";
      this.type = "consent";
      this.content = "";
      this.format = "html";
      this.file = null;
      this.$refs.modal.show();
    },
    showEdit(template) {
      this.is_editing = true;
      this.title = template.title;
      this.type = template.type;
      this.content = template.content;
      this.format = (template.format == 'html') ? 'rich' : template.format;
      this.template = template;
      this.file = null;
      this.$refs.modal.show();
    },
    onSubmit() {
      if (this.is_editing) {
        this.modifyTemplate();
      } else {
        this.createNewTemplate();
      }
    },
    modifyTemplate() {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          title: this.title,
          type: this.type,
          content: this.content,
          format: this.format == "rich" ? "html" : this.format,
        };
        axios
          .post(`/document_template/${this.template.id}`, params)
          .then((response) => {
            this.$emit("submit", response.data);
            this.msgwindow.success("Plantilla modificado con éxito");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            console.log("[ERR] modifyTemplate ", err);
            this.msgwindow.error("Error modificando plantilla!");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    createNewTemplate() {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          title: this.title,
          type: this.type,
          content: this.content,
          format: this.format == "rich" ? "html" : this.format,
        };

        axios
          .post("/document_template", params)
          .then((response) => {
            this.$emit("submit", response.data);
            this.msgwindow.success("Plantilla creada con éxito");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            console.log("[ERR] createNewTemplate ", err);
            this.msgwindow.error("Error creando plantilla!");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          // Get the Base64 string without the data URL prefix
          const base64String = reader.result.split(',')[1];
          resolve(base64String);
        };

        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    },
    onDelete() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post(`/document_template/${this.template.id}`, { _method: "delete" })
          .then((response) => {
            this.msgwindow.success("Plantilla borrada con éxito");
            this.$emit("submit");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            console.log("[ERR] onDelete", err);
            this.msgwindow.error("Error borrando plantilla");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    onEditorReady(quill) {
    }
  },
};
</script>

<style lang="scss">
#clinic-show-template {
  .modal-dialog {
    max-width: 75%;
  }

  .content-editor {
    height: 55vh;
  }

  #show_template_content .ql-container {
    height: 55vh;
    overflow-y: scroll;
  }
}
</style>
